import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Cookies from '../../utils/cookies';
import { RXDContext } from '../../context/RXDContext';
import { WPUser } from '../../types';

interface Props {
  path: string;
  exact: boolean;
  render: Function;
  userInfo: WPUser;
  userLoading: boolean;
}

const ProtectedRXDRoute: React.FC<Props> = ({
  path,
  exact = false,
  render,
  userInfo,
  userLoading,
}) => {
  const lms_token = Cookies.get('lms_token');
  const { rxdUserInfo } = useContext(RXDContext);

  if (userLoading) {
    return null;
  }

  //check to determine the correct redirect if there is no access
  if (!(!userLoading && userInfo?.subscription) && (!lms_token || !rxdUserInfo?.id)) {
    if (window?.frameElement) {
      return <Redirect to="/rxd/landing" />;
    } else if (!userInfo && window?.location?.href) {
      window.location.href = '/login';
      return null;
    } else if (!userInfo?.subscription && window?.location?.href) {
      window.location.href = '/pricing';
      return null;
    }
  }

  return (
    <Route path={path} exact={exact}>
      {render()}
    </Route>
  );
};

export default ProtectedRXDRoute;
